import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import SyncIcon from "@mui/icons-material/Sync";
import ModalSuccessCustom from "layouts/ModalSuccessCustom";
import { http } from "utils/http";
import { useAppDispatch } from "../redux/store/configureStore";
var SYNCED_STATUS = 1;
export default function DataSyncControl(param) {
    var _param_syncStatus = param.syncStatus, syncStatus = _param_syncStatus === void 0 ? 0 : _param_syncStatus, rowData = param.rowData, onSync = param.onSync, syncHandler = param.syncHandler, syncPayload = param.syncPayload, syncHandlerOptions = param.syncHandlerOptions, syncHandlerArgs = param.syncHandlerArgs, syncApiConfig = param.syncApiConfig, onSyncSuccess = param.onSyncSuccess, onSyncError = param.onSyncError, _param_successMessage = param.successMessage, successMessage = _param_successMessage === void 0 ? "ซิงค์ข้อมูลเรียบร้อย" : _param_successMessage;
    var dispatch = useAppDispatch();
    var _useState = _sliced_to_array(useState(Number(syncStatus) === SYNCED_STATUS ? SYNCED_STATUS : 0), 2), currentSyncStatus = _useState[0], setCurrentSyncStatus = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isSyncing = _useState1[0], setIsSyncing = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), showSuccess = _useState2[0], setShowSuccess = _useState2[1];
    useEffect(function() {
        setCurrentSyncStatus(Number(syncStatus) === SYNCED_STATUS ? SYNCED_STATUS : 0);
    }, [
        syncStatus
    ]);
    var resolveConfigValue = function(value) {
        return typeof value === "function" ? value(rowData) : value;
    };
    var requestSyncApi = function() {
        var _ref = _async_to_generator(function() {
            var configValue, resolvedConfig, url, _resolvedConfig_method, method, data, payload, params, headers, _resolvedConfig_withAuth, withAuth, requestOptions, resolvedUrl, accessToken, authorizationHeader;
            return _ts_generator(this, function(_state) {
                if (!syncApiConfig) return [
                    2,
                    undefined
                ];
                configValue = resolveConfigValue(syncApiConfig);
                resolvedConfig = typeof configValue === "string" ? {
                    url: configValue
                } : configValue || {};
                url = resolvedConfig.url, _resolvedConfig_method = resolvedConfig.method, method = _resolvedConfig_method === void 0 ? "post" : _resolvedConfig_method, data = resolvedConfig.data, payload = resolvedConfig.payload, params = resolvedConfig.params, headers = resolvedConfig.headers, _resolvedConfig_withAuth = resolvedConfig.withAuth, withAuth = _resolvedConfig_withAuth === void 0 ? true : _resolvedConfig_withAuth, requestOptions = _object_without_properties(resolvedConfig, [
                    "url",
                    "method",
                    "data",
                    "payload",
                    "params",
                    "headers",
                    "withAuth"
                ]);
                resolvedUrl = resolveConfigValue(url);
                if (!resolvedUrl) {
                    throw new Error("กรุณาระบุ url สำหรับซิงค์ข้อมูล");
                }
                accessToken = localStorage.getItem("accessToken");
                authorizationHeader = withAuth && accessToken ? {
                    Authorization: "Bearer ".concat(accessToken)
                } : {};
                return [
                    2,
                    http(_object_spread_props(_object_spread({}, requestOptions), {
                        method: method,
                        url: resolvedUrl,
                        data: resolveConfigValue(data !== null && data !== void 0 ? data : payload),
                        params: resolveConfigValue(params),
                        headers: _object_spread({}, authorizationHeader, resolveConfigValue(headers) || {})
                    }))
                ];
            });
        });
        return function requestSyncApi() {
            return _ref.apply(this, arguments);
        };
    }();
    var requestSyncHandler = function() {
        var _ref = _async_to_generator(function() {
            var _result_meta, handlerArgs, resolvedArgs, payload, options, dispatchedAction, result, _tmp;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof syncHandler !== "function") return [
                            2,
                            undefined
                        ];
                        if (syncHandlerArgs !== undefined) {
                            resolvedArgs = resolveConfigValue(syncHandlerArgs);
                            handlerArgs = Array.isArray(resolvedArgs) ? resolvedArgs : [
                                resolvedArgs
                            ];
                        } else {
                            payload = syncPayload === undefined ? rowData : resolveConfigValue(syncPayload);
                            options = resolveConfigValue(syncHandlerOptions);
                            handlerArgs = options === undefined ? [
                                payload
                            ] : [
                                payload,
                                options
                            ];
                        }
                        dispatchedAction = dispatch(syncHandler.apply(void 0, _to_consumable_array(handlerArgs)));
                        if (!(typeof (dispatchedAction === null || dispatchedAction === void 0 ? void 0 : dispatchedAction.unwrap) === "function")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatchedAction.unwrap()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            dispatchedAction
                        ];
                    case 3:
                        _tmp = _state.sent();
                        _state.label = 4;
                    case 4:
                        result = _tmp;
                        if (result === false || (result === null || result === void 0 ? void 0 : (_result_meta = result.meta) === null || _result_meta === void 0 ? void 0 : _result_meta.requestStatus) === "rejected") {
                            throw (result === null || result === void 0 ? void 0 : result.error) || new Error("ไม่สามารถซิงค์ข้อมูลได้");
                        }
                        return [
                            2,
                            result
                        ];
                }
            });
        });
        return function requestSyncHandler() {
            return _ref.apply(this, arguments);
        };
    }();
    var executeSync = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                if (typeof onSync === "function") {
                    return [
                        2,
                        onSync(rowData)
                    ];
                }
                if (typeof syncHandler === "function") {
                    return [
                        2,
                        requestSyncHandler()
                    ];
                }
                return [
                    2,
                    requestSyncApi()
                ];
            });
        });
        return function executeSync() {
            return _ref.apply(this, arguments);
        };
    }();
    var hasSyncAction = typeof onSync === "function" || typeof syncHandler === "function" || Boolean(syncApiConfig);
    var isSynced = currentSyncStatus === SYNCED_STATUS;
    var isDisabled = isSyncing || !hasSyncAction || isSynced;
    var handleSyncData = function() {
        var _ref = _async_to_generator(function(event) {
            var minimumModalDisplay, _ref, response, error;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        if (isDisabled) return [
                            2
                        ];
                        setIsSyncing(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        minimumModalDisplay = new Promise(function(resolve) {
                            return setTimeout(resolve, 400);
                        });
                        return [
                            4,
                            Promise.all([
                                Promise.resolve(executeSync()),
                                minimumModalDisplay
                            ])
                        ];
                    case 2:
                        _ref = _sliced_to_array.apply(void 0, [
                            _state.sent(),
                            1
                        ]), response = _ref[0];
                        if (!(typeof onSyncSuccess === "function")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            onSyncSuccess(response, rowData)
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        setCurrentSyncStatus(SYNCED_STATUS);
                        setIsSyncing(false);
                        setShowSuccess(true);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        setIsSyncing(false);
                        if (typeof onSyncError === "function") {
                            onSyncError(error, rowData);
                        }
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSyncData(event) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("button", {
                type: "button",
                "aria-label": "ซิงค์ข้อมูล",
                title: !hasSyncAction ? "ยังไม่ได้กำหนด API สำหรับซิงค์ข้อมูล" : isSynced ? "ซิงค์ข้อมูลแล้ว" : "ซิงค์ข้อมูล",
                disabled: isDisabled,
                onClick: handleSyncData,
                style: {
                    alignItems: "center",
                    backgroundColor: isSynced ? "#2DC76D" : "#F59E0B",
                    border: 0,
                    borderRadius: "50%",
                    color: "#FFFFFF",
                    cursor: isSyncing ? "wait" : isDisabled ? "not-allowed" : "pointer",
                    display: "inline-flex",
                    height: 30,
                    justifyContent: "center",
                    opacity: isDisabled ? 0.55 : 1,
                    padding: 5,
                    verticalAlign: "middle",
                    width: 30
                },
                children: /*#__PURE__*/ _jsx(SyncIcon, {
                    style: {
                        fontSize: 20
                    }
                })
            }),
            /*#__PURE__*/ _jsx(Modal, {
                show: isSyncing,
                backdrop: "static",
                keyboard: false,
                centered: true,
                size: "sm",
                children: /*#__PURE__*/ _jsxs(Modal.Body, {
                    className: "px-4 py-5 text-center",
                    children: [
                        /*#__PURE__*/ _jsx(Spinner, {
                            animation: "border",
                            role: "status",
                            style: {
                                color: "#BE0018",
                                height: 48,
                                width: 48
                            },
                            children: /*#__PURE__*/ _jsx("span", {
                                className: "visually-hidden",
                                children: "กำลังซิงค์ข้อมูล"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "fs-18 tc-7 mt-3",
                            children: "กำลังซิงค์ข้อมูล"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-muted mt-1",
                            children: "กรุณารอสักครู่"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ModalSuccessCustom, {
                show: showSuccess,
                onHide: function() {
                    return setShowSuccess(false);
                },
                textsuccess: successMessage
            })
        ]
    });
}
